module.exports = __webpack_public_path__ + "media/stop-12.3ff08019.mp3";